/**
 * Display order for the clinic picker.
 *
 * The list arrives in whatever order the clinics collection returns. Rather
 * than a full hand-maintained list, which would go stale with every new clinic,
 * a few clinics are pinned: FIRST to the top in this order, LAST to the bottom.
 * Everything else keeps its original relative order in between.
 */
const FIRST = ['tmates', 'scienceco']
const LAST = ['rose', 'fc2-bluestone']

function rank(id) {
  if (FIRST.includes(id)) return FIRST.indexOf(id) - FIRST.length
  if (LAST.includes(id)) return 1 + LAST.indexOf(id)
  return 0
}

export function orderClinicsForPicker(clinics) {
  return clinics
    .map((clinic, i) => ({ clinic, i }))
    .sort((a, b) => rank(a.clinic.id) - rank(b.clinic.id) || a.i - b.i)
    .map(({ clinic }) => clinic)
}
